export default __webpack_public_path__ + "static/media/vision-agency-logo-dark.9609b354.png";